import { getOnStorage, removeFromStorage } from './storageFunctions';

const SESSION_EXPIRED_MESSAGE = 'Sessão expirada. Por favor, entre com sua conta novamente.';
let isLoggingOut = false;

export const clearSessionStorage = () => {
  removeFromStorage('login_date');
  removeFromStorage('token_magento');
  removeFromStorage('token_aws');
  removeFromStorage('temporary_token_aws');
  removeFromStorage('rca');
  removeFromStorage('selected_client');
  removeFromStorage('selected_rca');
  removeFromStorage('datasets');
  removeFromStorage('discounts');
  removeFromStorage('rca_usuario');
  removeFromStorage('cart_id');
  removeFromStorage('user_login_data');
  removeFromStorage('selected_brand');
  removeFromStorage('new_data_sets');
  removeFromStorage('has_new_datasets');
  removeFromStorage('last_data_sync');
  localStorage.removeItem('@RCA_APP:selected_client');
  localStorage.removeItem('localTime');
  localStorage.removeItem('deviceTime');
  localStorage.removeItem('login_bootstrap');
};

const toStatusNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
};

export const getAxiosErrorStatus = (error: unknown): number | undefined => {
  const err = error as any;
  return (
    toStatusNumber(err?.response?.status) ??
    toStatusNumber(err?.status) ??
    toStatusNumber(err?.request?.status)
  );
};

const getRequestAuthHeader = (error: unknown): string => {
  const headers = (error as any)?.config?.headers;
  if (!headers) return '';

  const value =
    (typeof headers.get === 'function' ? headers.get('Authorization') || headers.get('authorization') : null) ??
    headers.Authorization ??
    headers.authorization ??
    '';

  return typeof value === 'string' ? value : String(value || '');
};

export const isLikelyCorsBlockedAuthError = (error: unknown): boolean => {
  const err = error as any;
  if (err?.response) return false;

  const code = String(err?.code || '');
  const message = String(err?.message || '').toLowerCase();
  const isNetworkFailure = code === 'ERR_NETWORK' || message.includes('network error');
  if (!isNetworkFailure) return false;

  if (typeof navigator !== 'undefined' && navigator.onLine === false) return false;

  return getRequestAuthHeader(error).toLowerCase().startsWith('bearer ');
};

export const isUnauthorizedAxiosError = (error: unknown): boolean => {
  const status = getAxiosErrorStatus(error);
  if (status === 401 || status === 403) return true;

  if (isLikelyCorsBlockedAuthError(error)) return true;

  const message = String((error as any)?.message || '').toLowerCase();
  const responseMessage = String((error as any)?.response?.data?.message || '').toLowerCase();
  const combined = `${message} ${responseMessage}`;

  return (
    combined.includes('unauthorized') ||
    combined.includes('acesso negado') ||
    combined.includes('access denied') ||
    combined.includes('forbidden') ||
    combined.includes('expired')
  );
};

export const forceSessionExpiredLogout = async (message = SESSION_EXPIRED_MESSAGE) => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  clearSessionStorage();
  window.alert(message);

  try {
    const { deleteDB } = await import('@/talons/dbFunctions/useDBFunctions');
    await deleteDB();
  } catch (error) {
    console.error('Falha ao limpar IndexedDB na expiração de sessão:', error);
  }

  window.location.reload();
};

export const isUnauthorizedGraphQLError = (graphQLErrors: readonly any[] | undefined): boolean => {
  if (!graphQLErrors?.length) return false;

  return graphQLErrors.some((error) => {
    const category = String(error?.extensions?.category || '').toLowerCase();
    const message = String(error?.message || '').toLowerCase();
    return (
      category.includes('authorization') ||
      category.includes('graphql-authentication') ||
      message.includes('unauthorized') ||
      message.includes('acesso negado')
    );
  });
};

export const hasActiveSession = (): boolean => {
  return Boolean(getOnStorage('token_magento') && getOnStorage('rca_usuario'));
};
